import{AsyncSubject as t}from"../AsyncSubject.js";import{multicast as r}from"./multicast.js";function n(){return function(n){return r(new t)(n)}}export{n as publishLast};
